export default {
    path: 'pay_manage',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/pay_manage/List'),
    meta: {title:'下发通道'},
	children: [
	]
}